import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { pluralize } from 'utils'

export function showSuccessfulMoveToast(fileCount: number, url: string, selectedFolderName: string | null | undefined) {
  const message = () => {
    if (selectedFolderName) {
      return (
        <span>
          <b>{fileCount}</b> {pluralize('item', fileCount)} moved to <b>{selectedFolderName}</b>!
        </span>
      )
    } else {
      return (
        <span>
          <b>{fileCount}</b> {pluralize('folder', fileCount)} {fileCount > 1 ? 'have' : 'has'} moved to become a top
          level folder!
        </span>
      )
    }
  }

  showToastMessage(<span>{message()}</span>, 'success', {
    variant: 'proceed',
    type: 'link',
    to: url,
    label: 'Go to Project',
  })
}
